import React, { useState, useEffect } from 'react';
import styles from './RoomStatus.module.css';
import apiService from '../api/apiService';

export const RoomStatus = ({ hotelId }) => {
  const [roomStatusData, setRoomStatusData] = useState({
    occupied: { clean: 0, dirty: 0, inProgress: 0, total: 0 },
    available: { clean: 0, dirty: 0, inProgress: 0, total: 0 },
  });

  useEffect(() => {
    // Fetch room data from the /rooms/ endpoint
    const fetchRoomStatus = async () => {
      try {
        const response = await apiService.get(`/rooms/?hotel=${hotelId}`);

        // Initialize counters for occupied and available room statuses
        const occupied = { clean: 0, dirty: 0, inProgress: 0, total: 0 };
        const available = { clean: 0, dirty: 0, inProgress: 0, total: 0 };

        // Loop through rooms and categorize them based on their status
        response.forEach(room => {
          if (room.status === 'occupied') {
            occupied.total++;
            if (room.hk_status === 'clean') occupied.clean++;
            if (room.hk_status === 'dirty') occupied.dirty++;
            if (room.hk_status === 'in_progress') occupied.inProgress++;
          } else if (room.status === 'available') {
            available.total++;
            if (room.hk_status === 'clean') available.clean++;
            if (room.hk_status === 'dirty') available.dirty++;
            if (room.hk_status === 'in_progress') available.inProgress++;
          }
        });

        // Update the room status data state
        setRoomStatusData({ occupied, available });
      } catch (error) {
        console.error('Error fetching room data:', error);
      }
    };

    fetchRoomStatus();
  }, []);

  const data = [
    {
      title: 'Occupied Rooms',
      details: [
        {
          label: 'Total Occupied Rooms',
          value: roomStatusData.occupied.total,
          className: 'occupiedValue',
        },
        {
          label: 'Clean',
          value: roomStatusData.occupied.clean,
          className: 'cleanValue',
        },
        {
          label: 'Dirty',
          value: roomStatusData.occupied.dirty,
          className: 'dirtyValue',
        },
        {
          label: 'In Progress',
          value: roomStatusData.occupied.inProgress,
          className: 'inProgressValue',
        },
      ],
    },
    {
      title: 'Available Rooms',
      details: [
        {
          label: 'Total Available Rooms',
          value: roomStatusData.available.total,
          className: 'availableValue',
        },
        {
          label: 'Clean',
          value: roomStatusData.available.clean,
          className: 'cleanValue',
        },
        {
          label: 'Dirty',
          value: roomStatusData.available.dirty,
          className: 'dirtyValue',
        },
        {
          label: 'In Progress',
          value: roomStatusData.available.inProgress,
          className: 'inProgressValue',
        },
      ],
    },
  ];

  return (
    <div className={styles.statusSection}>
      <div className={styles.roomStatus}>
        {data.map((section, index) => (
          <div key={index} className={styles.roomStatusColumn}>
            <h3>{section.title}</h3>
            <div className={styles.roomStatusDetails}>
              {section.details.map((item, idx) => (
                <div key={idx} className={styles.detailRow}>
                  <span>{item.label}</span>
                  <span className={styles[item.className]}>{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
